if (!customElements.get('custom-related-products')) {
  class CustomRelatedProducts extends HTMLElement {
    constructor() {
      super();
      this._swiperContainer = null;
      this._swiperInstance = null;
      this.columnsDesktop = this.querySelector("data-columns-desktop") ?? 6;
      this.addEventListener("product-recommendations:loaded", () => {
        this._swiperContainer = this.querySelector('.swiper');
        this.initializeSwiper();
      });
    }

    connectedCallback() {
      requestAnimationFrame(() => {
        this._swiperContainer = this.querySelector('.swiper');
        this.initializeSwiper();
      });
    }

    initializeSwiper() {
      if (!this._swiperContainer) {
        console.error('Swiper container not found');
        return;
      }

      const nextButton = this.querySelector('.custom-related-products__navigation .swiper-btn-next');
      const prevButton = this.querySelector('.custom-related-products__navigation .swiper-btn-prev');

      this._swiperInstance = new Swiper(this._swiperContainer, {
        slidesPerGroup: 1,
        slidesPerView: 1.8,
        spaceBetween: 10,
        loop: false,
        direction: "horizontal",
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        breakpoints: {
          590: {
            slidesPerGroup: 1,
            slidesPerView: 2.2,
            spaceBetween: 10,
          },
          769: {
            slidesPerGroup: 1,
            slidesPerView: 3,
            spaceBetween: 15,
          },
          990: {
            slidesPerGroup: 1,
            slidesPerView: 4,
            spaceBetween: 15,
          },
          1200: {
            slidesPerGroup: 1,
            slidesPerView: (this.columnsDesktop - 1) > 4 ? (this.columnsDesktop - 1) : 4,
            spaceBetween: 15,
          },
          1400: {
            slidesPerGroup: 1,
            slidesPerView: this.columnsDesktop,
            spaceBetween: 15,
          },
        }
      });
    }
  }

  customElements.define('custom-related-products', CustomRelatedProducts);
}